export type IconName = 'eye' | 'home' | 'book' | 'chart' | 'settings' | 'flask' | 'arrow' | 'back' | 'keyboard' | 'check' | 'spark' | 'clock' | 'close';
const paths: Record<IconName, string> = {
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12ZM15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  home: 'm3 10 9-7 9 7M5 9v11h5v-6h4v6h5V9',
  book: 'M12 5C9 3 5 3 2 4v15c3-1 7-1 10 1 3-2 7-2 10-1V4c-3-1-7-1-10 1Zm0 0v15',
  chart: 'M4 3v17h17M8 16v-5m5 5V7m5 9v-4',
  settings: 'M4 7h16M4 17h16M9 4v6m6 4v6',
  flask: 'M9 3h6m-5 0v7L4 19a1.2 1.2 0 0 0 1 2h14a1.2 1.2 0 0 0 1-2l-6-9V3M7 15h10',
  arrow: 'M4 12h16m-6-6 6 6-6 6', back: 'M20 12H4m6-6-6 6 6 6',
  keyboard: 'M3 5h18v14H3ZM7 9h.01M11 9h.01M15 9h.01M18 9h.01M7 12h.01M11 12h.01M15 12h.01M18 12h.01M8 16h8',
  check: 'm5 12 4 4L19 6', spark: 'm12 2 2.5 7.5L22 12l-7.5 2.5L12 22l-2.5-7.5L2 12l7.5-2.5L12 2Z',
  clock: 'M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0ZM12 6v6l4 2', close: 'm6 6 12 12M18 6 6 18',
};
export function Icon({ name, size = 20 }: { name: IconName; size?: number }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name]} /></svg>;
}
